
$('.js-app-store-btn').on('click', function(event) {
    let $links = $(this).data('links');
    $('#modalHiringLink').attr('href', $links.hiring);
    $('#modalLookingLink').attr('href', $links.looking);

    var device = $(event.target).data('device');
    $('#modalAppSelector').find('.js-modal-description').text('Help us point you to the correct version of Jobstack on the ' + device);

    $('#modalAppSelector').modal('show')
});

// Swap modal description based on which jobstack button is clicked
// $('#modalAppSelector').on('show.bs.modal', function (event) {
//     var device = $(event.relatedTarget).data('device');
//     $(this).find('.modal-description p').text('Help us point you to the correct version of Jobstack on ' + device);
// });


// Adds pause/play setup for any video inside of the .video-container
const videoContainers = document.querySelectorAll('.video-container');

function toggleVideoPlay(video, button) {
    if (video.paused) {
        video.play();
        button.classList.remove('play');
        button.classList.add('pause');
        button.setAttribute('aria-label', 'Pause Video');
    } else {
        video.pause();
        button.classList.remove('pause');
        button.classList.add('play');
        button.setAttribute('aria-label', 'Play Video');
    }
}

// Attach event listeners to each video container
videoContainers.forEach(container => {
    const video = container.querySelector('video');
    const button = container.querySelector('.video-control');

    // Set initial button state
    button.classList.add(video.paused ? 'play' : 'pause');

    // Add click event listener to the button
    button.addEventListener('click', () => {
        toggleVideoPlay(video, button);
    });
});